export const env = {
  donationUrl: import.meta.env.VITE_DONATION_URL || "",
  parentPortalUrl: import.meta.env.VITE_PARENT_PORTAL_URL || "",
  tadsApplyUrl: import.meta.env.VITE_TADS_APPLY_URL || "",
  calendarApiUrl: import.meta.env.VITE_CALENDAR_API_URL || "",
  googleAnalyticsMeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || "",
  siteUrl: import.meta.env.VITE_SITE_URL || "https://zionclassical.org",
  schoolName: import.meta.env.VITE_SCHOOL_NAME || "Zion Classical Academy",
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL || "principal@zionclassical.org",
  schoolPhone: import.meta.env.VITE_SCHOOL_PHONE || "402-462-5012",
  schoolAddress: import.meta.env.VITE_SCHOOL_ADDRESS || "465 S Marian Road, Hastings, NE 68901",
  schoolStreetAddress: import.meta.env.VITE_SCHOOL_STREET_ADDRESS || "465 S Marian Road",
  schoolCity: import.meta.env.VITE_SCHOOL_CITY || "Hastings",
  schoolRegion: import.meta.env.VITE_SCHOOL_REGION || "NE",
  schoolPostalCode: import.meta.env.VITE_SCHOOL_POSTAL_CODE || "68901",
  schoolCountry: import.meta.env.VITE_SCHOOL_COUNTRY || "US",
  facebookUrl: import.meta.env.VITE_FACEBOOK_URL || ""
};
